import '@babel/polyfill'
import TaskEditor from './components/TaskEditor'
import ActivityEditor from './components/ActivityEditor'
import Errors from './components/Errors'
import AchievementAdd from './components/AchievementAdd'

const LoginPage = () => import('./pages/LoginPage.vue')
const MainPage = () => import('./pages/MainPage.vue')
const Main = () => import('./components/Main.vue')
const Users = () => import('./components/Users.vue')
const ExtUsers = () => import('./components/ExtUsers.vue')
const Poles = () => import('./components/Poles.vue')
const PoleEditor = () => import('./components/pole/PoleEditor.vue')
const PoleStructure = () => import('./components/pole/PoleStructure.vue')
const Achievements = () => import('./components/Achievements.vue')
const Surveys = () => import('./components/Surveys.vue')
const SurveyEditor = () => import('./components/SurveyEditor.vue')
const Tasks = () => import('./components/Tasks.vue')
const Articles = () => import('./components/Articles.vue')
const Movies = () => import('./components/Movies.vue')
const Audio = () => import('./components/Audio.vue')
const Pictures = () => import('./components/Pictures.vue')
const Badges = () => import('./components/Badges.vue')
const BadgeEditor = () => import('./components/BadgeEditor.vue')
const VoiceCommands = () => import('./components/VoiceCommands.vue')
const Chat = () => import('./components/Chat.vue')
const Settings = () => import('./components/Settings.vue')
const Push = () => import('./components/Push.vue')
const RepoViewer = () => import('./components/pole/RepoViewer.vue')
const Activities = () => import('./components/Activities.vue')
const Categories = () => import('./components/Categories.vue')
const KbCategories = () => import('./components/KbCategories.vue')
const ArticleEditor = () => import('./components/ArticleEditor.vue')
const Links = () => import('./components/Links.vue')
// const Publications = () => import('./components/Publications.vue')

const routes = [
    {
        name: 'login',
        path: '/login',
        component: LoginPage,
    },
    {
        name: 'login-action',
        path: '/login/:action',
        component: LoginPage
    },
    {
        path: '',
        component: MainPage,
        children:
            [
                {
                    name: 'main',
                    path: '',
                    component: Main,
                },
                {
                    name: 'users',
                    path: 'uzytkownicy',
                    component: Users,
                },
                {
                    name: 'ext-users',
                    path: 'uzytkownicy-aplikacji',
                    component: ExtUsers,
                },
                {
                    name: 'goals',
                    path: 'bieguny',
                    component: Poles,
                },
                {
                    name: 'pole-edit',
                    path: 'bieguny/edytuj/:poleId',
                    components: {
                        default: PoleEditor,
                        right: RepoViewer
                    }
                },
                {
                    name: 'pole-add',
                    path: 'bieguny/dodaj/:group-:phase',
                    components: {
                        default: PoleEditor,
                        right: RepoViewer
                    }
                },
                {
                    name: 'polearticles',
                    path: 'artykuly-biegunowe',
                    component: Articles,
                },
                {
                    name: 'polearticles-add',
                    path: 'artykuly-biegunowe/dodaj',
                    components: {
                        default: ArticleEditor,
                        right: RepoViewer
                    }
                },
                {
                    name: 'polearticles-edit',
                    path: 'artykuly-biegunowe/edytuj/:articleId',
                    components: {
                        default: ArticleEditor,
                        right: RepoViewer
                    }
                },

                {
                    name: 'pole-structure',
                    path: 'bieguny/struktura/:poleId',
                    components: {
                        default: PoleStructure
                    }
                },
                {
                    name: 'achievements',
                    path: 'osiagniecia',
                    component: Achievements,
                },
                {
                    name: 'achievements-add',
                    path: 'osiagniecia/dodaj',
                    components: {
                        default: AchievementAdd,
                        right: RepoViewer
                    },
                },
                {
                    name: 'achievements-edit',
                    path: 'osiagniecia/:groupId',
                    components: {
                        default: AchievementAdd,
                        right: RepoViewer
                    },
                },
                {
                    name: 'activities',
                    path: 'aktywnosci',
                    component: Activities,
                },
                {
                    name: 'activity-add',
                    path: 'aktywnosci/dodaj',
                    components: {
                        default: ActivityEditor,
                        right: RepoViewer
                    }
                },
                {
                    name: 'activity-edit',
                    path: 'aktywnosci/edytuj/:activityTypeId',
                    components: {
                        default: ActivityEditor,
                        right: RepoViewer
                    }
                },
                {
                    name: 'categories',
                    path: 'kategorie',
                    component: Categories,
                },
                {
                    name: 'kbCategories',
                    path: 'kategorie-bazy-wiedzy',
                    components: {
                        default: KbCategories,
                    }
                },
                {
                    name: 'tasks',
                    path: 'zadania',
                    component: Tasks,
                },
                {
                    name: 'task-add',
                    path: 'zadania/dodaj',
                    components: {
                        default: TaskEditor,
                        right: RepoViewer
                    },
                },
                {
                    name: 'task-edit',
                    path: 'zadania/:optionalTaskId',
                    components: {
                        default: TaskEditor,
                        right: RepoViewer
                    },
                },
                {
                    name: 'surveys',
                    path: 'ankiety/zwykle',
                    component: Surveys,
                },
                {
                    name: 'surveys-qualifying',
                    path: 'ankiety/kwalifikacyjne',
                    component: Surveys,
                },
                {
                    name: 'survey-add',
                    path: 'ankiety/dodaj',
                    components: {
                        default: SurveyEditor,
                        right: RepoViewer
                    },
                },
                {
                    name: 'survey-add-qualifying-with-params',
                    path: 'ankiety/dodaj-kwalifikacyjna/:category/:group',
                    components: {
                        default: SurveyEditor,
                        right: RepoViewer
                    },
                },
                {
                    name: 'survey-add-qualifying',
                    path: 'ankiety/dodaj-kwalifikacyjna',
                    components: {
                        default: SurveyEditor,
                        right: RepoViewer
                    },
                },
                {
                    name: 'survey-edit',
                    path: 'ankiety/edytuj/:surveyId',
                    components: {
                        default: SurveyEditor,
                        right: RepoViewer
                    },
                },
                {
                    name: 'audio',
                    path: 'audio',
                    component: Audio,
                },
                {
                    name: 'pictures',
                    path: 'zdjecia',
                    component: Pictures,
                },
                {
                    name: 'badges',
                    path: 'odznaki',
                    component: Badges,
                },
                {
                    name: 'badge-edit',
                    path: 'odznaki/edytuj/:badgeId',
                    components: {
                        default: BadgeEditor,
                        right: RepoViewer
                    }
                },
                {
                    name: 'badge-add',
                    path: 'odznaki/dodaj',
                    components: {
                        default: BadgeEditor,
                        right: RepoViewer
                    }
                },
                {
                    name: 'movies',
                    path: 'filmy',
                    component: Movies,
                },
                {
                    name: 'articles',
                    path: 'artykuly',
                    component: Articles,
                },
                {
                    name: 'article-add',
                    path: 'artykuly/dodaj',
                    components: {
                        default: ArticleEditor,
                        right: RepoViewer
                    }
                },
                {
                    name: 'article-edit',
                    path: 'artykuly/edytuj/:articleId',
                    components: {
                        default: ArticleEditor,
                        right: RepoViewer
                    }
                },
                {
                    name: 'voice-commands',
                    path: 'komendy-glosowe',
                    component: VoiceCommands,
                },
                {
                    name: 'chat',
                    path: 'czat',
                    component: Chat,
                },
                {
                    name: 'settings',
                    path: 'ustawienia',
                    component: Settings,
                },
                {
                    name: 'push',
                    path: 'push',
                    component: Push,
                },
                {
                    name: 'links',
                    path: 'linki',
                    component: Links
                },
                // {
                //     name: 'publications',
                //     path: 'publications',
                //     component: Publications
                // },
                {
                    name: 'errors',
                    path: 'errors',
                    component: Errors
                },
            ],
    },
]

export default routes